import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchDesignation } from '../Services/Designation';
import { RootState } from '../store';

export const getAllDesignations = createAsyncThunk(
  'designationApi/getAllDesignations',
  async (params?: any) => {
    const response = await fetchDesignation(params);
    return response?.results || [];
  }
);

interface DesignationState {
  designationData: {
    loading: boolean;
    data: any[];
  };
}

const initialState: DesignationState = {
  designationData: {
    loading: false,
    data: [],
  },
};

export const designationApiSlice = createSlice({
  name: 'designationApi',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllDesignations.pending, (state) => {
        state.designationData.loading = true;
      })
      .addCase(getAllDesignations.fulfilled, (state, action) => {
        state.designationData.data = action.payload;
        state.designationData.loading = false;
      })
      .addCase(getAllDesignations.rejected, (state) => {
        state.designationData.loading = false;
      });
  },
});

export const selectDesignationData = (state: RootState) =>
  state.designationApi.designationData;

export const selectLoadingDesignation = (state: RootState) =>
  state.designationApi.designationData.loading;

export default designationApiSlice.reducer;
